<template>
  <div class="input-group">
    <input :type="type" :id="id" :value="property" @change="onChange" class="form-control" :class="classStr" :style="styleStr">
  </div>
</template>

<script>
export default {
  name: 'EditOrderConfirmationProp',
  props: {
    id: {
      type: String,
      default: ''
    },
    property: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    classStr: {
      type: String,
      default: ''
    },
    styleStr: {
      type: String,
      default: ''
    },
    rowIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onChange(event) {
      this.$emit('changed', event.target.value, this.rowIndex);
    }
  }
}
</script>
